(function () {
  if (window.__byteAvisStepScrollFix) return;
  window.__byteAvisStepScrollFix = true;

  var ACTIVE_CLASS = 'apo-step-child-active';
  var STEP_CLASS = 'apo-step-child';
  var CONTAINER_ID = 'avpoptions-container__v2';
  var SCROLL_EXTRA_OFFSET = 16;

  var lastActiveStepIndex = null;
  var scrollFixTimer = null;

  function getActiveStep(container) {
    return container.querySelector('.' + STEP_CLASS + '.' + ACTIVE_CLASS);
  }

  function getStepIndex(step) {
    return step ? step.getAttribute('data-step-index') : null;
  }

  function getScrollOffset() {
    var headerHeight = parseFloat(
      getComputedStyle(document.documentElement).getPropertyValue('--header-height')
    );
    return (Number.isFinite(headerHeight) ? headerHeight : 0) + SCROLL_EXTRA_OFFSET;
  }

  function scrollActiveStepIntoView(container) {
    var activeStep = getActiveStep(container);
    if (!activeStep) return;

    var rect = activeStep.getBoundingClientRect();
    var isOutOfComfortableView = rect.top < 0 || rect.top > window.innerHeight * 0.6;
    if (!isOutOfComfortableView) return;

    var targetTop = window.scrollY + rect.top - getScrollOffset();
    window.scrollTo({ top: Math.max(targetTop, 0), behavior: 'smooth' });
  }

  function handleMutations(mutations, container) {
    var stepChanged = false;

    for (var i = 0; i < mutations.length; i++) {
      var mutation = mutations[i];
      if (mutation.type !== 'attributes' || mutation.attributeName !== 'class') continue;

      var target = mutation.target;
      if (!(target instanceof Element) || !target.classList.contains(STEP_CLASS)) continue;

      var wasActive = (mutation.oldValue || '').indexOf(ACTIVE_CLASS) !== -1;
      var isActive = target.classList.contains(ACTIVE_CLASS);

      if (isActive !== wasActive) {
        stepChanged = true;
        break;
      }
    }

    if (!stepChanged) return;

    var activeIndex = getStepIndex(getActiveStep(container));
    if (activeIndex === lastActiveStepIndex) return;
    lastActiveStepIndex = activeIndex;

    clearTimeout(scrollFixTimer);
    scrollFixTimer = setTimeout(function () {
      scrollActiveStepIntoView(container);
    }, 60);
  }

  function start(container) {
    lastActiveStepIndex = getStepIndex(getActiveStep(container));

    var observer = new MutationObserver(function (mutations) {
      handleMutations(mutations, container);
    });

    observer.observe(container, {
      attributes: true,
      attributeFilter: ['class'],
      attributeOldValue: true,
      subtree: true,
    });
  }

  function init() {
    var container = document.getElementById(CONTAINER_ID);
    if (container) {
      start(container);
    } else {
      setTimeout(init, 400);
    }
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();
})();
